import { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const COOKIE_KEY = 'actcheck_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-[60] p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-ink/95 backdrop-blur-xl rounded-2xl p-5 sm:p-6 shadow-2xl border border-white/10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Cookie size={24} className="text-compliance-green flex-shrink-0 hidden sm:block" />
          <p className="flex-1 font-body text-sm text-white/80 leading-relaxed">
            We use cookies and similar technologies to improve your experience and analyse site usage.
            See our{' '}
            <Link to="/privacy-policy" className="text-compliance-green hover:underline">
              Privacy Policy
            </Link>{' '}
            for details.
          </p>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              data-testid="cookie-decline-btn"
              className="font-body text-sm text-white/60 hover:text-white transition-colors px-4 py-2"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              data-testid="cookie-accept-btn"
              className="bg-compliance-green hover:bg-compliance-green/90 text-white font-body font-semibold text-sm px-5 py-2.5 rounded-full transition-all hover:shadow-lg hover:shadow-compliance-green/25"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
